module.exports = __webpack_public_path__ + "assets/img/18_184_big.6b4e94f5.jpg";